var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "400", persistent: true },
      model: {
        value: _vm.dialogIsOpen,
        callback: function($$v) {
          _vm.dialogIsOpen = $$v
        },
        expression: "dialogIsOpen"
      }
    },
    [
      _c(
        "v-card",
        {
          staticClass:
            "dialog-box home-form-container building_structure_dialog"
        },
        [
          _c("h2", { staticClass: "floorbox-title" }, [
            _vm._v(
              _vm._s(
                _vm.objectToEdit
                  ? _vm.$t("Edit") + " " + _vm.$tc("Floorbox", 1)
                  : _vm.$t("New") + " " + _vm.$tc("Floorbox", 1)
              )
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex align-center mt-1" }, [
            _c(
              "div",
              { staticClass: "fraction-form-item", style: { flex: "1" } },
              [
                _c("label", { staticClass: "form-label-div" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("Color") + " *") +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("treeselect", {
                  staticClass: "form-input-select vertical-input-select",
                  attrs: {
                    value: _vm.objectData.color,
                    options: _vm.floorboxColors,
                    placeholder: null,
                    disableFuzzyMatching: ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "value-label",
                      fn: function(ref) {
                        var node = ref.node
                        return _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "row",
                              "align-items": "center"
                            }
                          },
                          [
                            _c("div", {
                              staticClass: "floorbox",
                              style: { backgroundColor: node.raw.id }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(node.raw.label))])
                          ]
                        )
                      }
                    },
                    {
                      key: "option-label",
                      fn: function(ref) {
                        var node = ref.node
                        return _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-direction": "row",
                              "align-items": "center"
                            }
                          },
                          [
                            _c("div", {
                              staticClass: "floorbox",
                              style: { backgroundColor: node.raw.id }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(node.raw.label))])
                          ]
                        )
                      }
                    }
                  ]),
                  model: {
                    value: _vm.objectData.color,
                    callback: function($$v) {
                      _vm.$set(_vm.objectData, "color", $$v)
                    },
                    expression: "objectData.color"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "fraction-form-item", style: { flex: "1" } },
              [
                _c("label", [_vm._v(_vm._s("" + _vm.$tc("Floor", 1)) + "*")]),
                _vm._v(" "),
                _c("treeselect", {
                  staticClass: "form-input-select vertical-input-select",
                  attrs: {
                    options: _vm.floorOptions,
                    disableFuzzyMatching: "",
                    disabled: _vm.selectedObject.type === "Floor" ? true : false
                  },
                  model: {
                    value: _vm.objectData.floor_uuid,
                    callback: function($$v) {
                      _vm.$set(_vm.objectData, "floor_uuid", $$v)
                    },
                    expression: "objectData.floor_uuid"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "fraction-form-item", style: { flex: "1" } },
              [
                _c("label", [_vm._v(_vm._s("" + _vm.$t("Column")) + " *")]),
                _vm._v(" "),
                _c("treeselect", {
                  staticClass: "form-input-select vertical-input-select",
                  attrs: {
                    options: _vm.columnsOptions,
                    disableFuzzyMatching: "",
                    disabled: _vm.objectToEdit
                      ? true
                      : _vm.selectedObject.type === "Column"
                      ? true
                      : false
                  },
                  model: {
                    value: _vm.objectData.column_uuid,
                    callback: function($$v) {
                      _vm.$set(_vm.objectData, "column_uuid", $$v)
                    },
                    expression: "objectData.column_uuid"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fraction-form-item mt-1" },
            [
              _c("label", [_vm._v(_vm._s("" + _vm.$tc("TechnicalLocal", 1)))]),
              _vm._v(" "),
              _c("treeselect", {
                staticClass: "form-input-select vertical-input-select",
                attrs: {
                  disableFuzzyMatching: "",
                  options: _vm.technicalOptions
                },
                model: {
                  value: _vm.objectData.technical_local_uuid,
                  callback: function($$v) {
                    _vm.$set(_vm.objectData, "technical_local_uuid", $$v)
                  },
                  expression: "objectData.technical_local_uuid"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex align-center mt-1" }, [
            _c(
              "div",
              { style: { flex: "1" } },
              [
                _c("input-field", {
                  attrs: {
                    label: _vm.$tc("Label", 1) + " *",
                    "input-type": "text",
                    size: "large",
                    value: _vm.objectData.label
                  },
                  model: {
                    value: _vm.objectData.label,
                    callback: function($$v) {
                      _vm.$set(_vm.objectData, "label", $$v)
                    },
                    expression: "objectData.label"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "fraction-form-item mt-1", style: { flex: "1" } },
              [
                _c("label", [_vm._v(_vm._s("" + _vm.$t("MaterialReference")))]),
                _vm._v(" "),
                _c("treeselect", {
                  staticClass: "form-input-select vertical-input-select",
                  attrs: {
                    disableFuzzyMatching: "",
                    options: _vm.materialOptions
                  },
                  model: {
                    value: _vm.objectData.material_id,
                    callback: function($$v) {
                      _vm.$set(_vm.objectData, "material_id", $$v)
                    },
                    expression: "objectData.material_id"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fraction-form-item mt-1" },
            [
              _c("label", [
                _vm._v(
                  _vm._s(
                    !!_vm.objectData.technical_local_uuid
                      ? _vm.$t("Cable-inReference") + " *"
                      : "" + _vm.$t("Cable-inReference")
                  )
                )
              ]),
              _vm._v(" "),
              _c("treeselect", {
                staticClass: "form-input-select vertical-input-select",
                attrs: {
                  options: _vm.cableTypeSixOptions,
                  disableFuzzyMatching: "",
                  disabled: !!!_vm.objectData.technical_local_uuid
                },
                model: {
                  value: _vm.objectData.cable_in_material_id,
                  callback: function($$v) {
                    _vm.$set(_vm.objectData, "cable_in_material_id", $$v)
                  },
                  expression: "objectData.cable_in_material_id"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex align-center mt-1" }, [
            _c(
              "div",
              { style: { flex: "1" } },
              [
                _c("input-field", {
                  attrs: {
                    label: !!_vm.objectData.technical_local_uuid
                      ? _vm.$t("Length") + " *"
                      : "" + _vm.$t("Length"),
                    "input-type": "float",
                    size: "large",
                    value: _vm.objectData.cable_in_length,
                    fieldDisabled: !!!_vm.objectData.technical_local_uuid
                  },
                  model: {
                    value: _vm.objectData.cable_in_length,
                    callback: function($$v) {
                      _vm.$set(_vm.objectData, "cable_in_length", $$v)
                    },
                    expression: "objectData.cable_in_length"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "fraction-form-item", style: { flex: "2" } },
              [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      !!_vm.objectData.technical_local_uuid
                        ? _vm.$tc("Owner", 1) + " *"
                        : "" + _vm.$tc("Owner", 1)
                    )
                  )
                ]),
                _vm._v(" "),
                _c("treeselect", {
                  staticClass: "form-input-select vertical-input-select",
                  attrs: {
                    options: _vm.ownerOptions,
                    disableFuzzyMatching: "",
                    disabled: !!!_vm.objectData.technical_local_uuid
                  },
                  model: {
                    value: _vm.objectData.cable_in_owner_id,
                    callback: function($$v) {
                      _vm.$set(_vm.objectData, "cable_in_owner_id", $$v)
                    },
                    expression: "objectData.cable_in_owner_id"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "fraction-form-item mt-1" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("Cable-outReference") + " *"))
              ]),
              _vm._v(" "),
              _c("treeselect", {
                staticClass: "form-input-select vertical-input-select",
                attrs: {
                  options: _vm.cableTypeFiveOptions,
                  disableFuzzyMatching: ""
                },
                model: {
                  value: _vm.objectData.cable_out_material_id,
                  callback: function($$v) {
                    _vm.$set(_vm.objectData, "cable_out_material_id", $$v)
                  },
                  expression: "objectData.cable_out_material_id"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex align-center mt-1" }, [
            _c(
              "div",
              { staticClass: "fraction-form-item" },
              [
                _c("label", [_vm._v(_vm._s(_vm.$tc("Owner", 1) + " *"))]),
                _vm._v(" "),
                _c("treeselect", {
                  staticClass: "form-input-select vertical-input-select",
                  attrs: {
                    options: _vm.ownerOptions,
                    disableFuzzyMatching: ""
                  },
                  model: {
                    value: _vm.objectData.cable_out_owner_id,
                    callback: function($$v) {
                      _vm.$set(_vm.objectData, "cable_out_owner_id", $$v)
                    },
                    expression: "objectData.cable_out_owner_id"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("v-checkbox", {
            staticClass: "multi-selection-checkbox mt-1",
            staticStyle: { "z-index": "100" },
            attrs: {
              "input-value": _vm.objectData.active,
              label: _vm.$t("Active"),
              color: "#4fa2b7",
              ripple: false,
              "hide-details": true,
              disableFuzzyMatching: ""
            },
            model: {
              value: _vm.objectData.active,
              callback: function($$v) {
                _vm.$set(_vm.objectData, "active", $$v)
              },
              expression: "objectData.active"
            }
          }),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                {
                  staticClass: "secondary-button",
                  attrs: { ripple: false, text: "" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close-dialog")
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(_vm.$t("Cancel")) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "main-button",
                  attrs: {
                    disabled: !_vm.objectCanBeCreated,
                    ripple: false,
                    text: ""
                  },
                  on: { click: _vm.saveObject }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.objectToEdit ? _vm.$t("Edit") : _vm.$t("Create")
                      ) +
                      "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d628845", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d628845","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/FloorboxForm.vue
// module id = null
// module chunks = 